export default __webpack_public_path__ + "static/media/Gesture_white_Stroke.d8d10b31.svg";